

	const hamburger = document.querySelector(".mobile-menu__hamburger");
	const navMenu = document.querySelector(".mobile-menu__nav-menu");
	const navLink = document.querySelectorAll(".mobile-menu__nav-link");

	var clickCount = 0;

if(hamburger)
{
	hamburger.addEventListener("click", mobileMenu);


	for (i = 0; i < navLink.length; i++) {
		navLink[i].addEventListener("click", closeMenu);
	}

	function mobileMenu() {
		clickCount++;
	    hamburger.classList.toggle("mobile-menu__hamburger-active");
	    navMenu.classList.toggle("active");
	    // add listener to disable scroll
		if (clickCount%2 == 0) {
			window.onscroll=function(){};
		}
		else{
			window.onscroll=function(){
				window.scrollTo(0, 0);
			};
		}
	}

	function closeMenu() {
		clickCount++;
		window.onscroll=function(){};
	    hamburger.classList.remove("mobile-menu__hamburger-active");
	    navMenu.classList.remove("active");
	}

}
